import { z } from 'zod';

export const adminProductSortingSchema = z.enum(['created-new', 'created-old', 'updated-new', 'updated-old']).nullish();

export type AdminProductSortingSchema = z.infer<typeof adminProductSortingSchema>;
